module.exports = __webpack_public_path__ + "static/media/Balance.86bc2145.svg";